<template>
	<div class="coupon" :style="{ zIndex: new Date().getTime() - 1737447000000, paddingTop: `100px` }">
		<div class="count-down">
			<span class="text" style="font-size: 14px;">抢券</span>
			<img style="width: 20px;margin: 0 6px;" src="../../assets/lives/coupon-3-fill.png" mode="widthFix">
			<countdown @countdown_show="countdown_show" type="2" :endTime="coupon.text.timeOut"
				style="color: #fa3c59;font-size: 14px;">
			</countdown>
			<!-- <u-count-down v-if="coupon.text.timeOut- new Date().getTime()>0"
				:time="coupon.text.timeOut- new Date().getTime()" format="HH:mm:ss" @finish="finish"></u-count-down> -->
		</div>
		<!-- 有可领取的券-->
		<img style="width:320px;" src="../../assets/lives/coupontop.png" mode="widthFix"
			v-if="coupon.status == 1"></img>
		<div class="dialog_detail" v-if="coupon.status == 1">
			<div class="couponName">
				{{ coupon.text.couponName }}
			</div>
			<div class="couponAmt">
				￥{{ coupon.text.couponAmt / 100 }}
			</div>
			<div class="couponDesc">
				{{ coupon.text.couponDesc }}
			</div>
			<div class="">
				<img class="kp" style="width: 140px;" src="../../assets/lives/coupon2.png" mode="widthFix">
			</div>
			<div class="bottom">
				<div @click="receive" class="dialog_btn">立即领取</div>
			</div>
		</div>

		<!-- 已经领取优惠券 -->
		<img style="width:240px;" src="../../assets/lives/gxhd.png" mode="widthFix" v-if="coupon.status == 2">
		<div class="dialog_detail" v-if="coupon.status == 2">
			<img class="kp" style="width: 140px;" src="../../assets/lives/coupon2.png" mode="widthFix">
			<div class="bottom">
				<div @click="useCoupon(1)" class="dialog_btn">去使用</div>
				<div style="color: #EE8025;font-size: 12px;margin-top: 11px;">
					请及时使用，避免失效
				</div>
			</div>
		</div>

		<!-- 仅限领取一张 -->
		<div v-if="coupon.status == 3 || coupon.status == 4" style="height: 100px;"></div>
		<div class="dialog_detail" v-if="coupon.status == 3">
			<div class="couponDesc" style="font-size: 14px;">
				{{ coupon.text.message ? coupon.text.message : '您有一张优惠券待使用' }}
			</div>
			<div style="color: #EE8025;font-size: 12px;margin-top: 11px;">
				您的优惠券已放入"我的卡券"中
			</div>
			<div class="bottom">
				<div @click="useCoupon(3)" class="dialog_btn">点击查看</div>
			</div>
		</div>

		<!-- 很遗憾 -->
		<div class="dialog_detail" v-if="coupon.status == 4">
			<img style="width: 103px;" src="../../assets/lives/hyh.png" mode="widthFix">
			<div class="couponDesc" style="font-size: 14px;margin-top: 28px;color: #42191A;">
				{{ coupon.text.message }}
			</div>
			<div style="color: #999999;font-size: 12px;margin-top: 40px;padding-bottom: 18px;" @click="useCoupon(3)">
				已领取的优惠券可在“我的卡券”中查看
			</div>
		</div>
		<img style="width: 26px;margin-top: 17px;" src="../../assets/lives/close.png" mode="widthFix" @click="finish">
	</div>
</template>

<script>
import {
	mapState
} from 'vuex'
import countdown from "@/components/lives/countdown.vue";
export default {

	name: "applyControl",
	components: {
		countdown
	},
	data() {
		return {
			show_countdown: false,
		}
	},
	computed: {
		clientWidth() {
			return document.body.clientWidth
		},
		...mapState({
			coupon: (state) => state.coupon,

		})

	},
	methods: {
		countdown_show(status) {
			this.show_countdown = status;
		},
		// 领取优惠券
		receive() {
			let _this = this
			this.$liveapi.receiveCoupon({
				couponId: this.coupon.text.couponId,
				issuanceId: this.coupon.text.issuanceId,
				sceneId: sessionStorage.getItem('live_id'),
				sceneType: 'room'
			}).then(res => {

				// 领取成功
				if (res.data.code == 0) {
					_this.$store.commit("set_coupon", {
						text: {
							..._this.coupon.text,
							message: res.data.msg
						},
						status: 2
					})
				} else if (res.data.code == 90012) {
					// 已领取一张
					_this.$store.commit("set_coupon", {
						text: {
							..._this.coupon.text,
							message: res.data.msg
						},
						status: 3
					})
				} else if (res.data.code == 90013 || res.data.code == 90014) {
					// 没领到
					_this.$store.commit("set_coupon", {
						text: {
							..._this.coupon.text,
							message: res.data.msg
						},
						status: 4
					})
				}
			})
		},
		// 关闭弹窗
		finish() {
			this.$emit('close')
		},
		useCoupon(tabs) {
			this.$emit('useCoupon', tabs)
		},

	},
}
</script>
<style scoped>
.coupon .count-down {
	position: absolute;
	right: 0;
	top: 20px;
	height: 40px;
	display: flex;
	align-items: center;
	color: #FA3C59;
	padding-right: 10px;

	/* 
	/deep/ .u-count-down__text {
		color: #fff;
	} */
}

.coupon {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .6);
	/* display: flex;
		align-items: center;
		flex-direction: column; */
	font-size: 0;


}



.coupon .dialog_detail {
	width: 327px;
	background: linear-gradient(to bottom, #FDE6C3, #FFFFFF, #FFFFFF);
	border-radius: 20px;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
	text-align: center;
	padding: 33px 0;
	position: relative;
	top: 0 !important;


}


.coupon .couponHeader {
	position: absolute;
	width: 100%;
	top: -96px;
}

.coupon .couponName {
	font-size: 15px;
	font-weight: bold;
	color: #000;
	font-weight: bold;
}

.coupon .couponAmt {
	font-size: 28px;
	color: #F83948;
	font-weight: bold;
	margin-top: 20px;
}

.coupon .couponDesc {
	color: #343434;
	font-size: 14px;
	margin-top: 7px;
}

.coupon .bottom {
	margin-top: 16px;
	margin-bottom: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.coupon .dialog_btn {
	background: #F83948;
	color: #fff;
	border-radius: 25px;
	font-weight: bold;
	height: 46px;
	line-height: 46px;
	text-align: center;
	width: 180px;
	font-size: 14px;
	padding: 0;
}






.kp {
	width: 90px;
	animation: shake 1s infinite;
	transition: transform 0.2s ease-in-out;
}

/* 定义关键帧动画，来模拟铃铛摇动的过程 */
@keyframes shake {
	0% {
		transform: rotate(0deg);
		/* 初始状态，不旋转 */
	}

	25% {
		transform: rotate(10deg);
		/* 向一个方向旋转一定角度 */
	}

	50% {
		transform: rotate(-10deg);
		/* 向另一个方向旋转一定角度，模拟来回摆动 */
	}

	75% {
		transform: rotate(5deg);
	}

	100% {
		transform: rotate(0deg);
		/* 回到初始位置 */
	}
}
</style>